// components/Row.tsx
import { Tooltip } from '@/components/Tooltip';
import { parseEnrichment } from '@/sections/threats/utils';
import type { Vulnerability } from '@/types';

import { ThreatTag } from './ThreatTag';

interface RowProps {
  row: Vulnerability;
}

/**
 * Table row component for threat intel list view
 */
export function Row({ row }: RowProps) {
  const enrichment = parseEnrichment(row);
  const name = enrichment?.name || row.id;
  const description = enrichment?.description || '';

  return (
    <div className="border-chariot-stroke my-6 flex flex-col gap-2 border-b last:border-b-0">
      <h1
        data-testid="title"
        className="text-chariot-brand-primary group-[.is-selected]:text-chariot-text-primary cursor-pointer text-xl font-semibold"
      >
        {name}
      </h1>
      <Tooltip title={description} placement="bottom">
        <h3
          data-testid="description"
          className="text-chariot-text-primary truncate text-sm"
        >
          {description}
        </h3>
      </Tooltip>
      <ThreatTag vulnerability={enrichment} />
    </div>
  );
}
